<template>
  <div class="d-flex padding">
    <div class="d-flex flex m-0">

      <div v-if="!categoriesLoaded || !publishersLoaded" class="h-100 d-flex justify-content-center align-items-center">
        <img alt="Vue logo" src="@/assets/img/loading.gif" width="100px" height="100px">
      </div>
      <div v-else class="container-fluid">

        <div class="row">

          <div class="col-12">
            <div class="row">
              <div class="col-12 col-lg-3">
                <div class="block px-4 py-3">
                  <div class="row">
                    <div class="col-lg-3 col-6">
                      <div class="d-flex align-items-center i-con-h-a my-1">
                        <div>
                          <span class="avatar w-40 b-a b-2x">
                            <i class="i-con i-con-globe b-2x text-primary"><i></i></i>
                          </span>
                        </div>
                        <div class="mx-3">
                          <p class="box-amount"><strong>{{publishers.length}}</strong></p>
                          <small class="text-muted">Verlage</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <div class="block px-4 py-3">
                  <div class="row">
                    <div class="col-lg-3 col-6">
                      <div class="d-flex align-items-center i-con-h-a my-1">
                        <div>
                          <span class="avatar w-40 b-a b-2x">
                            <i class="i-con i-con-users b-2x text-success"><i></i></i>
                          </span>
                        </div>
                        <div class="mx-3">
                          <p class="box-amount"><strong>{{authors.length}}</strong></p>
                          <small class="text-muted">Autoren</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <div class="block px-4 py-3">
                  <div class="row">
                    <div class="col-lg-3 col-6">
                      <div class="d-flex align-items-center i-con-h-a my-1">
                        <div>
                          <span class="avatar w-40 b-a b-2x">
                            <i class="i-con i-con-bookmark b-2x text-warning"><i></i></i>
                          </span>
                        </div>
                        <div class="mx-3">
                          <p class="box-amount"><strong>{{books.length}}</strong></p>
                          <small class="text-muted">Bücher</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 col-lg-3">
                <div class="block px-4 py-3">
                  <div class="row">
                    <div class="col-lg-3 col-6">
                      <div class="d-flex align-items-center i-con-h-a my-1">
                        <div>
                          <span class="avatar w-40 b-a b-2x">
                            <i class="i-con i-con-droplet b-2x text-danger"><i></i></i>
                          </span>
                        </div>
                        <div class="mx-3">
                          <p class="box-amount"><strong>{{categories.length}}</strong></p>
                          <small class="text-muted">Rechtsgebiete</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card p-4">
              Displayed
              <column-chart
                      :chartdata="statsLineData">
              </column-chart>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-12 col-lg-6">
            <div class="card p-4">
              Categories
              <donut-chart
                :chartdata="categoriesDonutData">
              </donut-chart>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="card p-4">
              Publishers
              <donut-chart
                :chartdata="publishersDonutData">
              </donut-chart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LineChart from '@/components/Charts/LineChart'
  import ColumnChart from '@/components/Charts/ColumnChart'
  import DonutChart from '@/components/Charts/DonutChart'

  export default {
    name: "DashBoard",

    components: {
      LineChart,
      DonutChart,
      ColumnChart,
    },

    computed: {
      categoriesDonutData() {
        let series = []
        let labels = []

        this.categories.forEach(cat => {
          if (cat.bookIds != undefined) {
            labels.push(cat.name)
            series.push(cat.bookIds.length)
          }
        })

        return {
          series: series,
          labels: labels
        }
      },

      publishersDonutData() {
        let series = []
        let labels = []

        this.publishers.forEach(cat => {
          labels.push(cat.name)
          if (cat.bookIds !== undefined) {
            series.push(cat.bookIds.length)
          }
        })

        return {
          series: series,
          labels: labels
        }
      },

      statsLineData() {
        let xaxis = [];
        let yaxis = [];
        let bookIds = [];

        this.stats.forEach(stat => {
          xaxis.push(this.$moment(stat.createdAtDay.seconds * 1000).format('DD-MM-YYYY'))
          yaxis.push(stat.displayed)
          bookIds.push(stat.bookIds)
        })

        return {
          xaxis: xaxis,
          yaxis: yaxis,
          bookIds: bookIds,
        }
      }
    },

    data () {
      return {}
    },

    mounted() {
    }
  }
</script>

<style scoped lang="scss">

  .box-amount {
    margin-bottom: 0;
    color: #137eff;
  }
</style>
